import { render } from "./ServiceTermsList.vue?vue&type=template&id=7bec4e4d&scoped=true"
import script from "./ServiceTermsList.vue?vue&type=script&lang=js"
export * from "./ServiceTermsList.vue?vue&type=script&lang=js"

import "./ServiceTermsList.vue?vue&type=style&index=0&id=7bec4e4d&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bec4e4d"]])

export default __exports__